var _rect, _path, _circle, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPendienteAbierto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 10,
    fill: "#F4813F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3604 15.4121L30.9832 22.9864C30.8696 23.6129 30.5395 24.1796 30.0506 24.5877C29.5618 24.9957 28.9451 25.219 28.3084 25.2188H15.1711L15.6655 27.9375H27.8438C28.4213 27.9372 28.9839 28.1208 29.4501 28.4615C29.9163 28.8023 30.262 29.2826 30.4371 29.8329C30.6122 30.3832 30.6076 30.975 30.4239 31.5225C30.2403 32.0701 29.8872 32.5449 29.4157 32.8784C28.9442 33.2118 28.3788 33.3866 27.8013 33.3773C27.2239 33.368 26.6644 33.1752 26.2039 32.8267C25.7433 32.4783 25.4057 31.9923 25.2397 31.4392C25.0738 30.886 25.0882 30.2944 25.2809 29.75H18.6254C18.7851 30.2 18.8234 30.6841 18.7367 31.1536C18.6499 31.6231 18.441 32.0615 18.131 32.4247C17.821 32.7878 17.4208 33.063 16.9708 33.2224C16.5207 33.3818 16.0366 33.4199 15.5671 33.3329C15.0976 33.2458 14.6593 33.0367 14.2964 32.7265C13.9334 32.4163 13.6585 32.016 13.4993 31.5658C13.3401 31.1157 13.3023 30.6315 13.3896 30.1621C13.4769 29.6927 13.6863 29.2545 13.9967 28.8917L10.8573 11.625H8.8125C8.57215 11.625 8.34164 11.5295 8.17168 11.3596C8.00173 11.1896 7.90625 10.9591 7.90625 10.7188C7.90625 10.4784 8.00173 10.2479 8.17168 10.0779C8.34164 9.90798 8.57215 9.8125 8.8125 9.8125H10.8573C11.2818 9.81231 11.693 9.96122 12.0189 10.2332C12.3448 10.5053 12.5649 10.8831 12.6406 11.3008L13.1939 14.3438H31.4688C31.6015 14.3438 31.7326 14.3729 31.8528 14.4292C31.9731 14.4855 32.0794 14.5674 32.1645 14.6694C32.2496 14.7713 32.3112 14.8906 32.345 15.019C32.3789 15.1473 32.3841 15.2815 32.3604 15.4121Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 12.5,
    r: 7.5,
    fill: "#F4813F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 12.5H30.3334",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 10.6667V14.3334",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 12.5C34 15.5376 31.5376 18 28.5 18C25.4624 18 23 15.5376 23 12.5C23 9.46244 25.4624 7 28.5 7C31.5376 7 34 9.46244 34 12.5Z",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPendienteAbierto);
export default __webpack_public_path__ + "static/media/iconPendienteAbierto.82d0879c1ae12d454ff403a0cf9931fd.svg";
export { ForwardRef as ReactComponent };